import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const educationPricingQuery = groq`*[_type == 'educationPricing' && currentPathname == $currentPathname][0]{
  ...,
  ctaBanner {
    reference-> ${CTABannerRefProjection}
  }
}`;
